<a class="trainer-other-training-card" [routerLink]="trainingUrl">
  <div class="training-cover-image">
    <img [appSrcset]="trainingCoverImageUrl" [pxWidth]="200" alt="" />
  </div>
  <div class="training-content">
    <div class="training-title">{{ title }}</div>
    <div class="training-description">{{ description }}</div>
  </div>
  <div class="icon">
    <i-feather name="chevron-right"></i-feather>
  </div>
</a>
